module.exports = __webpack_public_path__ + "static/media/29ADMSPC7.799b874d.jpg";